import {
	fetchPlayerDetail,
	fetchPlayerDetailFailed,
	fetchPlayerDetailSuccess,
} from "modules/actions";
import {Handedness, RequestState} from "modules/enums";
import {createReducer} from "redux-act";

interface IPlayerDetailStore {
	detail: ReturnType<typeof fetchPlayerDetailSuccess>["payload"];
	loadingState: RequestState;
}

const defaultState: IPlayerDetailStore = {
	detail: {
		seasonsStats: [],
		batterVsPitcherStats: {
			avg: 0,
			atBats: 0,
			batterHandedness: Handedness.LEFT,
			pitcherHandedness: Handedness.LEFT,
			hits: 0,
		},
		unitActions: [],
		lastActions: [],
		matchPlayerResults: {
			atBats: null,
			hits: null,
			playerId: null,
			result: null,
			sacFlies: null,
			streak: null,
		},
		personalizedDetailStats: null,
	},
	loadingState: RequestState.IDLE,
};

export const playerDetail = createReducer({}, defaultState)
	.on(fetchPlayerDetail, (state) => ({
		...state,
		detail: {
			...defaultState.detail,
		},
		loadingState: RequestState.REQUESTED,
	}))
	.on(fetchPlayerDetailSuccess, (state, payload) => ({
		...state,
		detail: {
			...state.detail,
			...payload,
		},
		loadingState: RequestState.RECEIVED,
	}))
	.on(fetchPlayerDetailFailed, (state) => ({
		...state,
		loadingState: RequestState.RECEIVED,
	}));
